import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NumberOnlyHelper {
  public static isNumber(value?: string | number): boolean {
    return value != null && value.toString().trim() !== '' && !isNaN(Number(value.toString().trim()));
  }
}
